<template>
  <div class="location-requester">
    <button
      :disabled="permissionState === $options.PERMISSION_STATE_IDS.DENIED"
      class="location-requester__btn btn btn--primary btn--small"
      @click="onCurrentCenterRequested"
    >
      {{ $t('wizard_step.centering.current_center_request_center') }}
    </button>
    <p
      v-if="permissionState === $options.PERMISSION_STATE_IDS.DENIED"
      class="location-requester__no-permission-warning u-reset"
    >
      {{ $t('wizard_step.centering.current_center_no_permission') }}
    </p>
  </div>
</template>

<script>
  const PERMISSION_STATE_IDS = {
    GRANTED: 'granted',
    PROMPT: 'prompt',
    DENIED: 'denied',
  }

  export default {
    props: {
      rotation: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        permissionState: PERMISSION_STATE_IDS.PROMPT,
      }
    },
    async created() {
      if (navigator.permissions && navigator.permissions.query) {
        const { state } = await navigator.permissions.query({ name: 'geolocation' })
        this.permissionState = state
      } else if (navigator.geolocation) {
        this.permissionState = PERMISSION_STATE_IDS.GRANTED
      } else {
        this.permissionState = PERMISSION_STATE_IDS.DENIED
      }
    },
    methods: {
      onCurrentCenterRequested() {
        navigator.geolocation.getCurrentPosition(({ coords }) => {
          this.$emit('update', [coords.longitude * -1, coords.latitude * -1, 0])
        })
      },
    },
    PERMISSION_STATE_IDS,
  }
</script>

<style lang="scss" src="./_location-requester.scss" />
